// redux/shipmentSlice.js
import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../constent'; // Assuming constants file for BASE_URL


// POST request to check shipment cost
export const GetShipmentCost = createAsyncThunk(
    "shipment/GetShipmentCost",
    async (shipmentData, thunkAPI) => {
      try {
        // console.log(shipmentData);
        const token = localStorage.getItem("accessToken");
        if (!token) throw new Error("No access token found");
        const response = await axios.post(
          `${BASE_URL}/calc/getOneShipmentCostByBody/`,
          shipmentData,
          {
          headers: {
            token: token,
          },
        }
        );
        // console.log(response.data)
        return response.data.data;
      } catch (error) {
        // console.error("Error:", error);
        return thunkAPI.rejectWithValue({} || error.message);
      }
    }
  );


// POST request to check shipment cost
export const checkShipmentCost = createAsyncThunk(
  "shipment/checkShipmentCost",
  async (shipmentData, thunkAPI) => {
    // console.log(shipmentData)
    try { 
      const currency = localStorage.getItem("currency");
      const response = await axios.post(
        `${BASE_URL}/calc/cost/`,
        shipmentData,
        {
          headers: { iso: currency },
        }
      );
      // console.log(response.data)
      return response.data;
    } catch (error) {
      return [];
    }
  }
);

// POST request to check shipment cost
export const checkShipmentCostPay = createAsyncThunk(
  "shipment/checkShipmentCostPay",
  async (shipmentData, thunkAPI) => {
    // console.log(shipmentData)
    try { 
      const currency = localStorage.getItem("currency");
      const response = await axios.post(
        `${BASE_URL}/calc/cost/`,
        shipmentData,
        {
          headers: { iso: currency },
        }
      );
      // console.log(response.data)
      return response.data;
    } catch (error) {
      // return [];
    }
  }
);
  // Create
  export const CreateShipmentCost = createAsyncThunk(
    "shipment/CreateShipmentCost",
    async (shipmentData, thunkAPI) => {
      try {
        // console.log(shipmentData);
        const token = localStorage.getItem("accessToken");
        if (!token) throw new Error("No access token found");
        const response = await axios.post(
          `${BASE_URL}/calc/createShipmentCost`,
          shipmentData,
          {
          headers: {
            token: token,
            // "Content-Type": "application/json",
          },
        },
        );
        // console.log(response.data)
        return response.data.data;
      } catch (error) {
        console.error("Error:", error);
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
      }
    }
  );
  
  // Update
  export const UpdateShipmentCost = createAsyncThunk(
    "shipment/UpdateShipmentCost",
    async ({shipmentData,id}, thunkAPI) => {
      try {
        // console.log(shipmentData);
        // console.log(id);
        const token = localStorage.getItem("accessToken");
        if (!token) throw new Error("No access token found");
        const response = await axios.put(
          `${BASE_URL}/calc/${id}/updateOneShipmentCost`,
          shipmentData,
          {
          headers: {
            token: token,
            // "Content-Type": "application/json",
          },
        },
        );
        // console.log(response.data)
        return response.data.data;
      } catch (error) {
        console.error("Error:", error);
        return thunkAPI.rejectWithValue(error.response?.data || error.message);
      }
    }
  );
  
const initialState = {
  cost: null, // Will hold the calculated shipment cost
  loading: false, // Loading state for the request
  error: null, // Error message in case the request fails
};

const shipmentSlice = createSlice({
  name: 'shipmentCost', // Slice name
  initialState,
  reducers: {
    // Action to clear the error state
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkShipmentCost.pending, (state) => {
        state.loading = true; // Set loading to true when the request starts
        state.error = null; // Clear any previous errors
      })
      .addCase(checkShipmentCost.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when the request succeeds
        state.cost = action.payload; // Store the calculated shipment cost
      })
      .addCase(checkShipmentCost.rejected, (state, action) => {
        state.loading = false; // Set loading to false when the request fails
        state.error = action.payload; // Store the error message
      });
  },
});

export const { clearError } = shipmentSlice.actions; // Export the clearError action

export default shipmentSlice.reducer;
